export default __webpack_public_path__ + "static/media/whatsapp-bill.a1091684.svg";